import Application from "../Application";
import BaseView, { DomainModel3D } from "./BaseView";
import pc from "../ParametricCache";
import { BufferGeometry, Material, Mesh } from "three";
import { Divider } from "../domain";

export default class DividerView extends BaseView {
    declare model: Divider;

    mesh: Mesh;

    constructor(model: DomainModel3D, app: Application) {
        super(model, app);
        this.init();
    }

    make(): void {
        this.mesh = new Mesh(new BufferGeometry(), new Material());
        this.mesh.castShadow = this.mesh.receiveShadow = true;
        this.mesh.userData.isSelectable = true;
        this.mesh.userData.isMovable = true;
        this.mesh.userData.cursor = 'row-resize';

        if(this.model.orientation == 'horizontal') {
            this.name = 'Horizontal Divider';
        } else if(this.model.orientation == 'vertical') {
            this.name = 'Vertical Divider';
        }

        this.highlights.add(this.mesh);
        this.add(this.mesh);
    }

    bind(): void {
        this.updateSize = this.updateSize.bind(this);
        this.model.bind('width', this.updateSize);
        this.model.on('height', this.updateSize);
        this.model.on('depth', this.updateSize);
        this.model.bind('thickness', () => {
            const scale = this.model.thickness / 0.75;
            if(this.model.orientation == 'horizontal') {
                this.mesh.scale.set(1, scale, 1);
            } else {
                this.mesh.scale.set(scale, 1, 1);
            }

            // Request the parent deal with a dimensional change. This is less
            // explicit than would be ideal, but it has the desired effect
            // without introducing a special API.
            this.model.parent.trigger('width');
        });

        this.bindMaterialArray(this.mesh, this.model.materials);
    }

    private updateSize() {
        this.updates.queue(
            () => {
                if(this.model.orientation == 'horizontal') {
                    return pc.make('FixedShelf', this.model.width, this.model.depth);
                } else if(this.model.orientation == 'vertical') {
                    return pc.make('Divider', this.model.height, this.model.depth);
                }
            },
            (geometry) => {
                this.mesh.geometry = geometry;
            }
        );
    }
}
